import React, {useContext, useEffect, useState, forwardRef} from 'react';
import {observer} from "mobx-react-lite";
import {useHistory, useLocation} from "react-router-dom";
import {Context} from "../../../../index";
import {fetchAllPlaces} from "../../../../http/placesApi";
import {ABOUT_US_ROUTE, BLOG_ROUTE, MAIN_ROUTE, PHOTO_GALLERY_ROUTE, PLACES_ROUTE, SHOP_ROUTE} from "../../../../utils/consts";
import PlaceNavItem from "../../../places/PlaceNavItem/PlaceNavItem";
import ErrorForm from "../../../modals/UserForms/ErrorForm/ErrorForm";

import styles from './Navigation.module.css';
import FormSelection from "../../../modals/UserForms/FormSelection/FormSelection";
import ym from "react-yandex-metrika";
import ModalPortal from "../../../../utils/ModalPortal";

const Navigation = observer(forwardRef((props, ref) => {
    const location = useLocation();
    const isFavouritesPage = location.pathname === '/favourites';

    const {add, helper} = useContext(Context);

    const history = useHistory();
    const [formSelectionVisible, setFormSelectionVisible] = useState(false);
    const [errorActive, setErrorActive] = useState(false);
    const [alertText, setAlertText] = useState('');

    const [activePath, setActivePath] = useState('');

    useEffect(() => {
        setActivePath(location.pathname);
    }, [location.pathname]);

    const navBarHeight = Number(helper.navBarHeight) - 1

    const containerStyles = {
        marginTop: isFavouritesPage ? `${navBarHeight}px` : `-1px`
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchAllPlaces();
                add.setPlaces(data.rows);
            } catch (error) {
                setAlertText('Ошибка при загрузке данных');
                setErrorActive(true);
            }
        };
        fetchData();
    }, [add]);

    return (
        <>
            <div
                className={`${styles.mainMenuContainer} ${isFavouritesPage ? styles.favouritesPageMod : ''}`}
                ref={ref}
                style={containerStyles}
            >
                <div className="container-custom">
                    <div className={styles.mainMenu}>
                        <ul className={styles.subMainMenu}>
                            <li className={`${styles.menuItem} ${activePath === MAIN_ROUTE ? styles.activeMenuItem : ''}`}>
                                <a
                                    onClick={() => {
                                        history.push(MAIN_ROUTE)
                                        ym('reachGoal','history.push(MAIN_ROUTE) NAVIGATION')
                                    }}
                                >
                                    Главная
                                </a>
                            </li>
                            <li className={`${styles.menuItem} ${activePath === SHOP_ROUTE || activePath === '/' || activePath === '' ? styles.activeMenuItem : ''}`}>
                                <a onClick={() => {
                                    history.push(SHOP_ROUTE)
                                    ym('reachGoal','history.push(SHOP_ROUTE) NAVIGATION')
                                }}>Жилье</a>
                            </li>
                            <li className={`${styles.menuItem} ${activePath.startsWith(PLACES_ROUTE) ? styles.activeMenuItem : ''}`}>
                                <a onClick={() => {
                                    history.push(PLACES_ROUTE)
                                    ym('reachGoal','history.push(PLACES_ROUTE) NAVIGATION')
                                }}
                                >
                                    Интересные места</a>
                                <ul className={styles.submenu}>
                                    <li>
                                        <a onClick={() => {
                                            history.push(PLACES_ROUTE + '/history');
                                            ym('reachGoal','history.push(PLACES_ROUTE) NAVIGATION')
                                        }}
                                        >
                                            История развития города
                                        </a>
                                    </li>
                                    <li>
                                        <a onClick={() => {
                                            history.push(PLACES_ROUTE + '/natural');
                                            ym('reachGoal','history.push(PLACES_ROUTE) NAVIGATION')
                                        }}
                                        >
                                            Природные богатства
                                        </a>
                                        <ul className={styles.submenu2}>
                                            {add.places.slice(1, 9).map(place =>
                                                <PlaceNavItem key={place.id} place={place}/>
                                            )}
                                        </ul>
                                    </li>
                                    <li>
                                        <a onClick={() => {
                                            history.push(PLACES_ROUTE + '/architecture');
                                            ym('reachGoal','history.push(PLACES_ROUTE) NAVIGATION')
                                        }}
                                        >
                                            Архитектурa и искусство
                                        </a>
                                        <ul className={styles.submenu2}>
                                            {add.places.slice(9, 22).map(place =>
                                                <PlaceNavItem key={place.id} place={place}/>
                                            )}
                                        </ul>
                                    </li>
                                    <li>
                                        <a onClick={() => {
                                            history.push(PLACES_ROUTE + '/leisure');
                                            ym('reachGoal','history.push(PLACES_ROUTE) NAVIGATION')
                                        }}
                                        >Досуг</a>
                                        <ul className={styles.submenu2}>
                                            {add.places.slice(22, 34).map(place =>
                                                <PlaceNavItem key={place.id} place={place}/>
                                            )}
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li className={`${styles.menuItem} ${activePath === PHOTO_GALLERY_ROUTE ? styles.activeMenuItem : ''}`}>
                                <a onClick={() => {
                                    history.push(PHOTO_GALLERY_ROUTE)
                                    ym('reachGoal','history.push(PHOTO_GALLERY_ROUTE) NAVIGATION')
                                }}>Фотогалерея</a>
                            </li>
                            <li className={`${styles.menuItem} ${activePath === BLOG_ROUTE ? styles.activeMenuItem : ''}`}>
                                <a onClick={() => {
                                    history.push(BLOG_ROUTE)
                                    ym('reachGoal','history.push(BLOG_ROUTE) NAVIGATION')
                                }}>Блог</a>
                            </li>
                            <li className={`${styles.menuItem} ${activePath.startsWith(ABOUT_US_ROUTE) ? styles.activeMenuItem : ''}`}>
                                <a onClick={() => {
                                    history.push(ABOUT_US_ROUTE)
                                    ym('reachGoal','history.push(ABOUT_US_ROUTE) NAVIGATION')
                                }}>О нас</a>
                                <ul className={styles.submenu}>
                                    <li>
                                        <a onClick={() => {
                                            history.push(ABOUT_US_ROUTE)
                                            ym('reachGoal','history.push(ABOUT_US_ROUTE) NAVIGATION')
                                        }}>Информация</a></li>
                                    <li>
                                        <a onClick={() => {
                                            history.push(ABOUT_US_ROUTE)
                                            ym('reachGoal','history.push(ABOUT_US_ROUTE) NAVIGATION')
                                        }}>Дорожная карта</a></li>
                                    <li>
                                        <a onClick={() => {
                                            history.push(ABOUT_US_ROUTE)
                                            ym('reachGoal','history.push(ABOUT_US_ROUTE) NAVIGATION')
                                        }}>Правовая информация</a></li>
                                    <li>
                                        <a onClick={() => {
                                            history.push(ABOUT_US_ROUTE)
                                            ym('reachGoal','history.push(ABOUT_US_ROUTE) NAVIGATION')
                                        }}>Контакты</a></li>
                                    <li>
                                        <a onClick={() => {
                                            history.push(ABOUT_US_ROUTE)
                                            ym('reachGoal','history.push(ABOUT_US_ROUTE) NAVIGATION')
                                        }}>Тарифы</a></li>
                                </ul>
                            </li>
                        </ul>
                        <div className={styles.selectionButtonWrapper}>
                            <button
                                className={styles.selectionButton}
                                onClick={
                                    () => {
                                        setFormSelectionVisible(true);
                                        ym('reachGoal','setFormSelectionVisible(true) NAVIGATION')
                                    }
                                }
                            >
                                <span className={styles.buttonTextSmall}>Бесплатный подбор</span>
                                <span className={styles.buttonTextBig}>Бесплатный подбор жилья</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ModalPortal>
                <FormSelection show={formSelectionVisible} onHide={() => setFormSelectionVisible(false)}/>
            </ModalPortal>
            <ErrorForm alert={alertText} show={errorActive} onHide={() => setErrorActive(false)}/>
        </>
    );
}));

export default Navigation;